// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Glyphicon } from 'react-bootstrap';
import { getActivityPhoto } from '../../activities/utils';

export default class ExperienceElement extends React.PureComponent {
  deleteExperience = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deleteExperience(
      event.currentTarget.getAttribute('data-name'),
      'activities'
    );
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, ind, notHeader } = this.props;
    const topBorder = notHeader && ind === 0 ? 'none' : '';
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      <tr key={value.title} data-name={ind} className='listrow moveable'>
        <td style={{ verticalAlign: 'middle', borderTop: topBorder }}>
          <Glyphicon glyph='option-vertical' />
        </td>
        <td style={{ width: '10%', borderTop: topBorder, minWidth: '60px' }}>
          <img
            src={getActivityPhoto(value)}
            style={{ width: '50px', height: '50px' }}
            alt='...'
            className='img-thumbnail'
          />
        </td>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        <td style={{ width: '90%', borderTop: topBorder }}>{value.title}</td>
        <td
          style={{
            width: '5%',
            textAlign: 'center',
            verticalAlign: 'middle',
            cursor: 'pointer',
            borderTop: topBorder,
          }}
        >
          <i
            className='fas fa-times'
            data-name={ind}
            onClick={this.deleteExperience}
          />
        </td>
      </tr>
    );
  }
}
